module.exports = __webpack_public_path__ + "img/menu.f1ef6eb4.png";